import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string, ext: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, { skipHeader: true });
    const workbook: XLSX.WorkBook = { Sheets: { 'Report': worksheet }, SheetNames: ['Report'] };
    if (ext == '.xlsx') {
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, excelFileName, ext);
    } else if (ext == '.csv') {
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'csv', type: 'array' });
      this.saveAsExcelFile(excelBuffer, excelFileName, ext);
    }
  }
  
  private saveAsExcelFile(buffer: any, fileName: string, extension: string): void {
    const data: Blob = new Blob([buffer]);
    FileSaver.saveAs(data, fileName + '_export' + extension);
  }
}